import React from 'react';

export default function AaChainVis(): JSX.Element {
  return (
    <>
      <path
        d="M15.5194 1.27216C16.1993 0.798826 17.1371 0.964005 17.6141 1.6413L33.5175 24.2233C33.7303 24.5256 33.8145 24.8789 33.7831 25.2194V59.4977C33.7829 60.3259 33.1112 60.9975 32.2831 60.9977H27.4716C26.6434 60.9976 25.9718 60.3259 25.9716 59.4977V27.0485L11.2157 6.0954C10.7391 5.41811 10.9041 4.48564 11.5839 4.01239L15.5194 1.27216Z"
        fill="#007FB5"
      />
      <path
        d="M15.5194 1.27216L14.948 0.451464L14.948 0.451491L15.5194 1.27216ZM17.6141 1.6413L18.4317 1.06551L18.4317 1.06549L17.6141 1.6413ZM33.5175 24.2233L34.3351 23.6475L34.3351 23.6475L33.5175 24.2233ZM33.7831 25.2194L32.7873 25.1274L32.7831 25.1733V25.2194H33.7831ZM33.7831 59.4977L34.7831 59.498V59.4977H33.7831ZM32.2831 60.9977V61.9977H32.2833L32.2831 60.9977ZM27.4716 60.9977L27.4714 61.9977H27.4716V60.9977ZM25.9716 59.4977H24.9716V59.498L25.9716 59.4977ZM25.9716 27.0485H26.9716V26.7317L26.7892 26.4727L25.9716 27.0485ZM11.2157 6.0954L10.3979 6.67092L10.3981 6.67118L11.2157 6.0954ZM11.5839 4.01239L12.1552 4.83308L12.1553 4.83305L11.5839 4.01239ZM15.5194 1.27216L16.0908 2.09285C16.3193 1.93375 16.6365 1.9898 16.7966 2.2171L17.6141 1.6413L18.4317 1.06549C17.6378 -0.0617858 16.0793 -0.336098 14.948 0.451464L15.5194 1.27216ZM17.6141 1.6413L16.7965 2.21709L32.6999 24.7991L33.5175 24.2233L34.3351 23.6475L18.4317 1.06551L17.6141 1.6413ZM33.5175 24.2233L32.6999 24.7991C32.7702 24.8989 32.7978 25.0135 32.7873 25.1274L33.7831 25.2194L34.7788 25.3114C34.8312 24.7443 34.6905 24.1523 34.3351 23.6475L33.5175 24.2233ZM33.7831 25.2194H32.7831V59.4977H33.7831H34.7831V25.2194H33.7831ZM33.7831 59.4977L32.7831 59.4975C32.783 59.7735 32.5589 59.9977 32.2828 59.9977L32.2831 60.9977L32.2833 61.9977C33.6636 61.9974 34.7827 60.8782 34.7831 59.498L33.7831 59.4977ZM32.2831 60.9977V59.9977H27.4716V60.9977V61.9977H32.2831V60.9977ZM27.4716 60.9977L27.4717 59.9977C27.1958 59.9977 26.9716 59.7737 26.9716 59.4975L25.9716 59.4977L24.9716 59.498C24.9719 60.8782 26.091 61.9975 27.4714 61.9977L27.4716 60.9977ZM25.9716 59.4977H26.9716V27.0485H25.9716H24.9716V59.4977H25.9716ZM25.9716 27.0485L26.7892 26.4727L12.0333 5.51962L11.2157 6.0954L10.3981 6.67118L25.154 27.6243L25.9716 27.0485ZM11.2157 6.0954L12.0335 5.51988C11.8762 5.29637 11.9299 4.99 12.1552 4.83308L11.5839 4.01239L11.0125 3.1917C9.87837 3.98128 9.60191 5.53985 10.3979 6.67092L11.2157 6.0954ZM11.5839 4.01239L12.1553 4.83305L16.0908 2.09282L15.5194 1.27216L14.948 0.451491L11.0125 3.19173L11.5839 4.01239Z"
        fill="#007FB5"
      />
      <g clipPath="url(#clip0_828_54440)">
        <g clipPath="url(#clip1_828_54440)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 15.9561 4.07397)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 20.0857 9.7261)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 24.2153 15.3782)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 28.3448 21.0304)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 32.4744 26.6825)"
            fill="#F0FAFE"
          />
        </g>
        <rect
          width="26.2839"
          height="1"
          transform="matrix(0.589938 0.807448 -0.810577 0.585632 15.1456 4.65961)"
          fill="#F0FAFE"
        />
      </g>
      <g clipPath="url(#clip2_828_54440)">
        <g clipPath="url(#clip3_828_54440)">
          <circle cx="30.1031" cy="56.9954" r="1.5" transform="rotate(-90 30.1031 56.9954)" fill="#F0FAFE" />
          <circle cx="30.1031" cy="49.9954" r="1.5" transform="rotate(-90 30.1031 49.9954)" fill="#F0FAFE" />
          <circle cx="30.1031" cy="42.9954" r="1.5" transform="rotate(-90 30.1031 42.9954)" fill="#F0FAFE" />
          <circle cx="30.1031" cy="35.9954" r="1.5" transform="rotate(-90 30.1031 35.9954)" fill="#F0FAFE" />
          <circle cx="30.1031" cy="28.9954" r="1.5" transform="rotate(-90 30.1031 28.9954)" fill="#F0FAFE" />
        </g>
        <rect
          x="29.6031"
          y="58.4954"
          width="33"
          height="1"
          transform="rotate(-90 29.6031 58.4954)"
          fill="#F0FAFE"
        />
      </g>
      <path
        d="M56.0568 1.27216C55.3769 0.798826 54.4391 0.964005 53.9621 1.6413L38.0587 24.2233C37.8459 24.5256 37.7617 24.8789 37.7931 25.2194V59.4977C37.7933 60.3259 38.465 60.9975 39.2931 60.9977H44.1046C44.9328 60.9976 45.6044 60.3259 45.6046 59.4977V27.0485L60.3605 6.0954C60.8372 5.41811 60.6721 4.48564 59.9923 4.01239L56.0568 1.27216Z"
        fill="#007FB5"
      />
      <path
        d="M56.0568 1.27216L56.6282 0.451464L56.6282 0.451491L56.0568 1.27216ZM53.9621 1.6413L53.1445 1.06551L53.1445 1.06549L53.9621 1.6413ZM38.0587 24.2233L37.2411 23.6475L37.2411 23.6475L38.0587 24.2233ZM37.7931 25.2194L38.7889 25.1274L38.7931 25.1733V25.2194H37.7931ZM37.7931 59.4977L36.7931 59.498V59.4977H37.7931ZM39.2931 60.9977V61.9977H39.2929L39.2931 60.9977ZM44.1046 60.9977L44.1048 61.9977H44.1046V60.9977ZM45.6046 59.4977H46.6046V59.498L45.6046 59.4977ZM45.6046 27.0485H44.6046V26.7317L44.787 26.4727L45.6046 27.0485ZM60.3605 6.0954L61.1783 6.67092L61.1781 6.67118L60.3605 6.0954ZM59.9923 4.01239L59.421 4.83308L59.4209 4.83305L59.9923 4.01239ZM56.0568 1.27216L55.4854 2.09285C55.2569 1.93375 54.9397 1.9898 54.7797 2.2171L53.9621 1.6413L53.1445 1.06549C53.9384 -0.0617858 55.4969 -0.336098 56.6282 0.451464L56.0568 1.27216ZM53.9621 1.6413L54.7797 2.21709L38.8763 24.7991L38.0587 24.2233L37.2411 23.6475L53.1445 1.06551L53.9621 1.6413ZM38.0587 24.2233L38.8764 24.7991C38.806 24.8989 38.7784 25.0135 38.7889 25.1274L37.7931 25.2194L36.7974 25.3114C36.745 24.7443 36.8857 24.1523 37.2411 23.6475L38.0587 24.2233ZM37.7931 25.2194H38.7931V59.4977H37.7931H36.7931V25.2194H37.7931ZM37.7931 59.4977L38.7931 59.4975C38.7932 59.7735 39.0173 59.9977 39.2934 59.9977L39.2931 60.9977L39.2929 61.9977C37.9126 61.9974 36.7935 60.8782 36.7931 59.498L37.7931 59.4977ZM39.2931 60.9977V59.9977H44.1046V60.9977V61.9977H39.2931V60.9977ZM44.1046 60.9977L44.1045 59.9977C44.3804 59.9977 44.6046 59.7737 44.6046 59.4975L45.6046 59.4977L46.6046 59.498C46.6043 60.8782 45.4852 61.9975 44.1048 61.9977L44.1046 60.9977ZM45.6046 59.4977H44.6046V27.0485H45.6046H46.6046V59.4977H45.6046ZM45.6046 27.0485L44.787 26.4727L59.5429 5.51962L60.3605 6.0954L61.1781 6.67118L46.4222 27.6243L45.6046 27.0485ZM60.3605 6.0954L59.5427 5.51988C59.7 5.29637 59.6464 4.99 59.421 4.83308L59.9923 4.01239L60.5637 3.1917C61.6978 3.98128 61.9743 5.53985 61.1783 6.67092L60.3605 6.0954ZM59.9923 4.01239L59.4209 4.83305L55.4854 2.09282L56.0568 1.27216L56.6282 0.451491L60.5638 3.19173L59.9923 4.01239Z"
        fill="#007FB5"
      />
      <g clipPath="url(#clip4_828_54440)">
        <g clipPath="url(#clip5_828_54440)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 55.6201 4.07397)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 51.4905 9.7261)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 47.3609 15.3782)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 43.2314 21.0304)"
            fill="#F0FAFE"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 39.1018 26.6825)"
            fill="#F0FAFE"
          />
        </g>
        <rect
          width="26.2839"
          height="1"
          transform="matrix(-0.589938 0.807448 0.810577 0.585632 56.4306 4.65961)"
          fill="#F0FAFE"
        />
      </g>
      <g clipPath="url(#clip6_828_54440)">
        <g clipPath="url(#clip7_828_54440)">
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 58.4954)" fill="#F0FAFE" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 51.4954)" fill="#F0FAFE" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 44.4954)" fill="#F0FAFE" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 37.4954)" fill="#F0FAFE" />
          <circle cx="1.5" cy="1.5" r="1.5" transform="matrix(0 -1 -1 0 42.9731 30.4954)" fill="#F0FAFE" />
        </g>
        <rect width="33" height="1" transform="matrix(0 -1 -1 0 41.9731 58.4954)" fill="#F0FAFE" />
      </g>
      <rect
        x="-0.120262"
        y="0.694702"
        width="24.8727"
        height="8.91985"
        rx="2"
        transform="matrix(-0.578282 -0.815837 0.818805 -0.573568 14.0466 32.1432)"
        fill="#8DB800"
      />
      <rect
        x="-0.120262"
        y="0.694702"
        width="24.8727"
        height="8.91985"
        rx="2"
        transform="matrix(-0.578282 -0.815837 0.818805 -0.573568 14.0466 32.1432)"
        stroke="#8DB800"
      />
      <g clipPath="url(#clip8_828_54440)">
        <g clipPath="url(#clip9_828_54440)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 6.05475 9.31995)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 10.1027 15.0308)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 14.1507 20.7417)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 18.1987 26.4525)"
            fill="#F6FFD7"
          />
        </g>
        <rect
          width="20.0118"
          height="1"
          transform="matrix(0.578282 0.815837 -0.818805 0.573568 5.81424 10.7094)"
          fill="#F6FFD7"
        />
      </g>
      <rect
        x="0.120262"
        y="0.694702"
        width="24.8727"
        height="8.91985"
        rx="2"
        transform="matrix(0.578282 -0.815837 -0.818805 -0.573568 57.8143 32.3394)"
        fill="#8DB800"
      />
      <rect
        x="0.120262"
        y="0.694702"
        width="24.8727"
        height="8.91985"
        rx="2"
        transform="matrix(0.578282 -0.815837 -0.818805 -0.573568 57.8143 32.3394)"
        stroke="#8DB800"
      />
      <g clipPath="url(#clip10_828_54440)">
        <g clipPath="url(#clip11_828_54440)">
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 65.9453 9.31995)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 61.8973 15.0308)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 57.8493 20.7417)"
            fill="#F6FFD7"
          />
          <circle
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 53.8013 26.4525)"
            fill="#F6FFD7"
          />
        </g>
        <rect
          width="20.0118"
          height="1"
          transform="matrix(-0.578282 0.815837 0.818805 0.573568 66.1858 10.7094)"
          fill="#F6FFD7"
        />
      </g>
      <defs>
        <clipPath id="clip0_828_54440">
          <rect
            width="26.2839"
            height="5.45688"
            fill="white"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 16.9519 3.35455)"
          />
        </clipPath>
        <clipPath id="clip1_828_54440">
          <rect
            width="26.2839"
            height="5.45688"
            fill="white"
            transform="matrix(0.589938 0.807448 -0.810577 0.585632 16.9519 3.35455)"
          />
        </clipPath>
        <clipPath id="clip2_828_54440">
          <rect width="32.6185" height="5.46765" fill="white" transform="matrix(0 -1 1 0 27.3693 58.4954)" />
        </clipPath>
        <clipPath id="clip3_828_54440">
          <rect width="32.6185" height="5.46765" fill="white" transform="matrix(0 -1 1 0 27.3693 58.4954)" />
        </clipPath>
        <clipPath id="clip4_828_54440">
          <rect
            width="26.2839"
            height="5.45688"
            fill="white"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 54.6243 3.35455)"
          />
        </clipPath>
        <clipPath id="clip5_828_54440">
          <rect
            width="26.2839"
            height="5.45688"
            fill="white"
            transform="matrix(-0.589938 0.807448 0.810577 0.585632 54.6243 3.35455)"
          />
        </clipPath>
        <clipPath id="clip6_828_54440">
          <rect width="32.6185" height="5.46765" fill="white" transform="matrix(0 -1 -1 0 44.2069 58.4954)" />
        </clipPath>
        <clipPath id="clip7_828_54440">
          <rect width="32.6185" height="5.46765" fill="white" transform="matrix(0 -1 -1 0 44.2069 58.4954)" />
        </clipPath>
        <clipPath id="clip8_828_54440">
          <rect
            width="21.0118"
            height="4.9499"
            fill="white"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 6.85306 8.76074)"
          />
        </clipPath>
        <clipPath id="clip9_828_54440">
          <rect
            width="21.0118"
            height="4.9499"
            fill="white"
            transform="matrix(0.578282 0.815837 -0.818805 0.573568 6.85306 8.76074)"
          />
        </clipPath>
        <clipPath id="clip10_828_54440">
          <rect
            width="21.0118"
            height="4.9499"
            fill="white"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 65.1469 8.76074)"
          />
        </clipPath>
        <clipPath id="clip11_828_54440">
          <rect
            width="21.0118"
            height="4.9499"
            fill="white"
            transform="matrix(-0.578282 0.815837 0.818805 0.573568 65.1469 8.76074)"
          />
        </clipPath>
      </defs>
    </>
  );
}
